import { Component, OnInit } from '@angular/core';
import { Subscription } from 'src/app/modules/entities/subscription';
import { SubscriptionService } from 'src/app/modules/services/subscription.service';

@Component({
  selector: 'app-subscription-list',
  templateUrl: './subscription-list.component.html',
  styleUrls: ['./subscription-list.component.css']
})
export class SubscriptionListComponent implements OnInit {
  constructor(private subscriptionService: SubscriptionService) { }

  subscriptionList: Subscription[] = [];

  ngOnInit(): void {  
    this.subscriptionService.getSubscriptions().subscribe({
      next: response => {
        if (response.status === 'success') {
          this.subscriptionList = response.data;
        }
      }
    });
  }
}